import { Elements } from '@tfo/common'
import * as React from 'react'
import { FormattedMessage } from 'react-intl'
import './NewOrderDone.scss'

const { Heading1, Paragraph } = Elements

export const NewOrderDone = () => {

    return (
        <div className='NewReportDoneAts'>
            <Heading1>
                <FormattedMessage id={'neworder.done.heading'} />
            </Heading1>
            <Paragraph className={'NewReportDone__BlockSpace--medium'}>
                <span>
                    <FormattedMessage id={'neworder.done.body.row1'} />
                </span>
                <span>
                    <FormattedMessage id={'neworder.done.body.row2'} />
                </span>
                <span>
                    <FormattedMessage id={'neworder.done.body.row3'} />
                </span>
                <span>
                    <FormattedMessage id={'neworder.done.body.row4'} />
                </span>
            </Paragraph>
        </div>
    )
}